<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="t('modalsDeleteProfileTitle')"
      [size]="'medium'"
      [ariaLabelledBy]="'delete-profile-title'"
      (closeModal)="onCancel()"
    >
      <div modal-content>
        <div class="flex items-start gap-4">
          <mat-icon class="text-[24px]! w-6! h-6! text-amber-600 shrink-0">warning</mat-icon>
          <div>
            <p
              id="delete-profile-message"
              class="font-dm text-sm text-ld-neutral-600"
              [innerHTML]="t('modalsDeleteProfileMessage')"
            ></p>
          </div>
        </div>
        <p id="delete-profile-confirm-question" class="font-dm text-sm font-semibold text-ld-neutral mt-4">
          {{ t('commonMessagesConfirmDelete') }}
        </p>
      </div>

      <div modal-footer>
        <button id="delete-profile-cancel-btn" type="button" class="btn-outline-ld-purple" (click)="onCancel()">
          {{ t('commonButtonsCancel') }}
        </button>
        <button id="delete-profile-confirm-btn" type="button" class="btn-solid-red" (click)="onConfirm()">
          {{ t('modalsDeleteProfileTitle') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
